import React, { useEffect, useContext } from "react"
import styled from "styled-components"
import { BrandsContext } from "../../providers/BrandsProvider"
import { FilterContext } from "../../providers/FilterProvider"
import { device } from "../../theme"
import { handleCharacters } from "../../utils/handleCharacters"

const StyledUl = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  margin-top: 22px;
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
`

const StyledLi = styled.li`
  color: #444;
  font-size: 0.9rem;
  cursor: pointer;
  margin-left: 12px;
  transition: transform 0.1s ease-in-out;

  transition: padding-left 0.1s linear;
  &.selected-brand {
    color: ${props => props.theme.colors.green} !important;
    padding-left: 4px !important;
  }

  &:hover {
    color: ${props => props.theme.colors.green};
    padding-left: 4px;
  }

  @media ${device.tablet} {
    &:hover {
      color: #444;
      padding-left: 0;
    }
  }

  @media ${device.phone} {
    font-size: 1rem;
  }
`

const Brands = React.memo(({ brands, category, gender }) => {
  const { state, dispatch } = useContext(FilterContext)
  let currentBrands = []

  const handleSelected = async brand => {
    currentBrands = [...state.selectedBrands, brand]

    if (state.selectedBrands.includes(brand)) {
      currentBrands = state.selectedBrands.filter(e => e !== brand)
    }

    const encodeBrands = encodeURIComponent(JSON.stringify(currentBrands))
    const activeGender = gender === "herre" ? "men" : "women"
    let url = `https://static8-api.herokuapp.com/lineout/search?gender=${activeGender}&sortBy=${state.sortBy}&size=20&page=0&category=${category}&brands=${encodeBrands}`
    if (!currentBrands.length) {
      url = `https://static8-api.herokuapp.com/lineout/feed?gender=${
        gender === "herre" ? "male" : "female"
      }&sortBy=${state.sortBy}&size=20&page=0&category=${category}`
    }

    await fetch(url)
      .then(res => res.json())
      .then(e => {
        dispatch({
          selectedBrands: [...currentBrands],
          products: [...e],
        })
      })
      .catch(err => console.log(err))

    document.body.scrollTop = 0
  }

  if (!brands) {
    return null
  }

  return (
    <StyledUl>
      {brands.map((brand, key) => (
        <StyledLi
          className={
            state.selectedBrands.includes(brand) ? "selected-brand" : ""
          }
          onClick={() => handleSelected(brand)}
          key={key}
        >
          {handleCharacters(brand)}
        </StyledLi>
      ))}
    </StyledUl>
  )
})

export default Brands
